// Signal-strength bars for the phone card footer. Four ascending bars,
// `level` of them filled (orange), the rest dim. `px` is the widget
// height — bars and gaps scale off it so the footer stays proportional
// to the card size.

interface SignalBarsProps {
  /** 0–4 filled bars; null (no telemetry) renders all dim. */
  level: number | null
  px: number
}

const HEIGHTS = [0.42, 0.62, 0.82, 1]

export function SignalBars({ level, px }: SignalBarsProps) {
  const filled = level ?? 0
  const barW = Math.max(2, px * 0.2)
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: Math.max(1.5, px * 0.12),
        height: px,
      }}
      aria-label={`Сигнал ${level ?? 0} из 4`}
    >
      {HEIGHTS.map((h, i) => (
        <div
          key={i}
          style={{
            width: barW,
            height: px * h,
            borderRadius: 1,
            background: i < filled ? '#fb923c' : '#3b4453',
          }}
        />
      ))}
    </div>
  )
}
